import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";

const HRQueryClient = new QueryClient();

const QueryProvider = ({ children }) => {
  return (
    <QueryClientProvider client={HRQueryClient}>{children}</QueryClientProvider>
  );
};

export default QueryProvider;
